var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "div",
        { staticClass: "page flex-col" },
        [
          _c(
            "div",
            {
              staticClass: "nav-bar_1 flex-col",
              style: {
                height:
                  _vm.noBusiness == "true" || _vm.noBusiness == null
                    ? "24.97vw"
                    : "12.97vw",
              },
            },
            [
              _vm.noBusiness == "true" || _vm.noBusiness == null
                ? _c("div", { staticClass: "group_choose" }, [
                    _c(
                      "span",
                      {
                        class: _vm.selectVal == "Products" ? "isactive" : "",
                        on: {
                          click: function ($event) {
                            return _vm.typeClick("Products")
                          },
                        },
                      },
                      [_vm._v("Products")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        class:
                          _vm.selectVal == "Manufacturers" ? "isactive" : "",
                        on: {
                          click: function ($event) {
                            return _vm.typeClick("Manufacturers")
                          },
                        },
                      },
                      [_vm._v("Manufacturers")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          position: "absolute",
                          top: "1.2vw",
                          left: "1.2vw",
                          "border-radius": "50%",
                          padding: "5px",
                          width: "30px",
                          height: "30px",
                        },
                        on: {
                          click: function ($event) {
                            _vm.dialogVisible = true
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "icon",
                            staticStyle: { width: "25px", height: "25px" },
                            attrs: {
                              t: "1773033703334",
                              viewBox: "0 0 1024 1024",
                              version: "1.1",
                              xmlns: "http://www.w3.org/2000/svg",
                              "p-id": "4755",
                              width: "128",
                              height: "128",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                fill: "#fff",
                                d: "M988.968421 512c0-264.084211-212.884211-476.968421-476.968421-476.968421C247.915789 35.031579 35.031579 247.915789 35.031579 512c0 261.389474 212.884211 476.968421 474.273684 476.968421h5.389474c261.389474 0 474.273684-215.578947 474.273684-476.968421zM167.073684 781.473684c-53.894737-70.063158-88.926316-156.294737-94.315789-250.610526h212.88421c0 43.115789 5.389474 115.873684 24.252632 188.631579-56.589474 13.473684-110.484211 32.336842-142.821053 61.978947zM164.378947 242.526316c32.336842 29.642105 86.231579 51.2 145.51579 64.673684-16.168421 72.757895-21.557895 142.821053-21.557895 185.936842H75.452632c2.694737-94.315789 35.031579-180.547368 88.926315-250.610526z m695.242106 0c53.894737 70.063158 86.231579 156.294737 91.621052 250.610526h-212.88421c0-43.115789-5.389474-113.178947-24.252632-185.936842 59.284211-13.473684 113.178947-35.031579 145.51579-64.673684zM700.631579 493.136842h-169.768421v-167.073684c43.115789 0 94.315789-5.389474 145.515789-13.473684 18.863158 72.757895 21.557895 142.821053 24.252632 180.547368z m-169.768421-204.8V83.536842c70.063158 37.726316 110.484211 115.873684 134.736842 194.021053-45.810526 8.084211-94.315789 10.778947-134.736842 10.778947z m-37.726316-204.8v204.8c-40.421053 0-88.926316-5.389474-134.736842-10.778947 21.557895-78.147368 64.673684-153.6 134.736842-194.021053z m0 242.526316v167.073684H323.368421c0-37.726316 5.389474-107.789474 24.252632-177.852631 53.894737 8.084211 107.789474 10.778947 145.515789 10.778947zM323.368421 530.863158h169.768421V700.631579c-37.726316 0-88.926316 2.694737-145.515789 13.473684-18.863158-75.452632-21.557895-145.515789-24.252632-183.242105z m169.768421 207.494737v202.105263c-70.063158-37.726316-110.484211-113.178947-134.736842-191.326316 45.810526-8.084211 94.315789-10.778947 134.736842-10.778947z m37.726316 202.105263v-202.105263c40.421053 0 88.926316 5.389474 134.736842 13.473684-24.252632 75.452632-64.673684 150.905263-134.736842 188.631579z m0-239.831579v-169.768421H700.631579c0 37.726316-5.389474 107.789474-24.252632 183.242105-51.2-8.084211-105.094737-13.473684-145.515789-13.473684z m207.494737-169.768421h212.88421c-5.389474 94.315789-37.726316 180.547368-94.315789 250.610526-32.336842-29.642105-86.231579-48.505263-142.821053-61.978947 16.168421-72.757895 21.557895-145.515789 24.252632-188.631579zM835.368421 215.578947c-26.947368 24.252632-75.452632 43.115789-129.347368 53.894737-21.557895-70.063158-56.589474-140.126316-113.178948-188.631579 94.315789 16.168421 177.852632 64.673684 242.526316 134.736842zM431.157895 80.842105c-56.589474 48.505263-91.621053 118.568421-113.178948 191.326316C264.084211 258.694737 215.578947 239.831579 188.631579 215.578947c64.673684-70.063158 148.210526-118.568421 242.526316-134.736842zM191.326316 811.115789c26.947368-24.252632 75.452632-43.115789 129.347368-53.894736 21.557895 70.063158 56.589474 140.126316 110.484211 185.936842-94.315789-16.168421-177.852632-64.673684-239.831579-132.042106zM592.842105 943.157895c56.589474-48.505263 88.926316-115.873684 110.484211-185.936842 53.894737 10.778947 102.4 29.642105 129.347368 53.894736-61.978947 67.368421-145.515789 115.873684-239.831579 132.042106z",
                                "p-id": "4756",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "group_1 flex-row main" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.keyword,
                      expression: "form.keyword",
                    },
                  ],
                  staticClass: "text_1",
                  attrs: { placeholder: "Search" },
                  domProps: { value: _vm.form.keyword },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "keyword", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "icon_1",
                  attrs: {
                    alt: "图片",
                    referrerpolicy: "no-referrer",
                    src: "https://lanhu.oss-cn-beijing.aliyuncs.com/psd2ufkj7jefd1xy0iz8taebxk821n9ovi096ce988-428c-4d3c-a6d8-399d10bdfca4",
                  },
                  on: { click: _vm.searchfun },
                }),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "nav-bar_2 flex-row justify-between" }, [
            _vm.phoneHomeImg
              ? _c(
                  "div",
                  {
                    staticClass: "phone_home_img",
                    on: {
                      click: function ($event) {
                        return _vm.homeChooseClick(true)
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "image_1",
                      attrs: {
                        alt: "图片",
                        referrerpolicy: "no-referrer",
                        src: "https://lanhu.oss-cn-beijing.aliyuncs.com/psn8au70ezjxep7omhhs6b9qgzapx1bxxo7649388a-6018-4a13-95b4-08e2386b0549",
                      },
                    }),
                  ]
                )
              : _c(
                  "div",
                  { staticClass: "phone_back", on: { click: _vm.goBack } },
                  [_vm._v("Back")]
                ),
            _vm._v(" "),
            _c("img", {
              staticClass: "image_2",
              attrs: {
                alt: "图片",
                referrerpolicy: "no-referrer",
                src: require("assets/img/applogo.png"),
              },
              on: {
                click: function ($event) {
                  return _vm.homeClick(true)
                },
              },
            }),
            _vm._v(" "),
            !_vm.shareType
              ? _c("div", { staticClass: "block flex-col" }, [
                  _c(
                    "div",
                    { staticClass: "image-wrapper flex-row justify-between" },
                    [
                      _c("div"),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "icon_2",
                        attrs: {
                          alt: "图片",
                          referrerpolicy: "no-referrer",
                          src: "https://lanhu.oss-cn-beijing.aliyuncs.com/psnx75b2d4itregzq3ajnbernkgjszsles844d0196a-f872-4edb-a646-3a529319e533",
                        },
                        on: { click: _vm.navBarRightClick },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.navBarRight
                    ? _c(
                        "div",
                        {
                          staticClass: "phone_nav",
                          style: {
                            top:
                              _vm.noBusiness == "true" || _vm.noBusiness == null
                                ? "calc(370 * 100vw / 1080)"
                                : "calc(240 * 100vw / 1080)",
                          },
                        },
                        [
                          _vm.noBusiness == "true" || _vm.noBusiness == null
                            ? _c(
                                "ul",
                                { staticClass: "flex-col justify-between" },
                                [
                                  _c(
                                    "li",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.homeClick(true)
                                        },
                                      },
                                    },
                                    [_vm._v("Home")]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.commondata,
                                    function (item, index) {
                                      return _c(
                                        "li",
                                        {
                                          key: index,
                                          on: {
                                            click: function ($event) {
                                              return _vm.ceramicsClick(item.id)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(item.categoryName) +
                                              "\n            "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _c(
                                "ul",
                                { staticClass: "flex-col justify-between" },
                                [
                                  _c(
                                    "li",
                                    { on: { click: _vm.businesshomeClick } },
                                    [_vm._v("Home")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    [
                                      _c(
                                        "el-dropdown",
                                        {
                                          attrs: { placement: "bottom-start" },
                                          on: {
                                            command: _vm.businessnewsClick,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "el-dropdown-link",
                                              staticStyle: {
                                                "font-size":
                                                  "calc(36 * 100vw / 1080)",
                                              },
                                            },
                                            [_vm._v("Profile")]
                                          ),
                                          _vm._v(" "),
                                          _c("i", {
                                            staticClass:
                                              "el-icon-arrow-down el-icon--right",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "el-dropdown-menu",
                                            {
                                              attrs: { slot: "dropdown" },
                                              slot: "dropdown",
                                            },
                                            [
                                              _c(
                                                "el-dropdown-item",
                                                {
                                                  attrs: {
                                                    command: "CompanyOverview",
                                                  },
                                                },
                                                [_vm._v("Company Overview")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-dropdown-item",
                                                {
                                                  attrs: {
                                                    command: "RatingsReviews",
                                                  },
                                                },
                                                [_vm._v("Ratings & Reviews")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    {
                                      on: { click: _vm.businessfeedbackClick },
                                    },
                                    [_vm._v("Feedback")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { on: { click: _vm.contactUsClick } },
                                    [_vm._v("ContactUs")]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.businessNav,
                                    function (item, index) {
                                      return _c(
                                        "li",
                                        {
                                          key: index,
                                          on: {
                                            click: function ($event) {
                                              return _vm.businessceramicsClick(
                                                item.id,
                                                false
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(item.categoryName) +
                                              "\n            "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          !_vm.shareType
            ? _c("div", { staticClass: "box_1" }, [
                _c("div", { staticClass: "flex-row justify-between main" }, [
                  _vm.noBusiness == "true" || _vm.noBusiness == null
                    ? _c("nav", { staticClass: "left flex-row" }, [
                        _c("div", [
                          _c(
                            "span",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.helpCenterClick("c")
                                },
                              },
                            },
                            [_vm._v("Help center")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.privacyClick(false)
                              },
                            },
                          },
                          [_vm._v("\n                Privacy    |\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "merchantSettlement",
                            on: {
                              click: function ($event) {
                                return _vm.unFacebookClick()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                Unbind Facebook    |\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "merchantSettlement",
                            on: {
                              click: function ($event) {
                                return _vm.unInstagramClick()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                Unbind Instagram\n          "
                            ),
                          ]
                        ),
                      ])
                    : _c("div", { staticClass: "left flex-row" }, [
                        _c("div", [_vm._v("Welcome to my store !")]),
                      ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "right",
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        gap: "20px",
                      },
                    },
                    [
                      _c(
                        "el-popover",
                        {
                          attrs: {
                            placement: "bottom",
                            width: "400",
                            trigger: "click",
                          },
                        },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-weight": "bold",
                                    "margin-bottom": "20px",
                                  },
                                },
                                [_vm._v("Set the language and currency")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "margin-bottom": "10px",
                                    "margin-top": "20px",
                                  },
                                },
                                [_vm._v("currency")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  on: { change: _vm.changeRateEvent },
                                  model: {
                                    value: _vm.rate,
                                    callback: function ($$v) {
                                      _vm.rate = $$v
                                    },
                                    expression: "rate",
                                  },
                                },
                                _vm._l(_vm.rateDataList, function (item) {
                                  return _c("el-option", {
                                    key: item.code,
                                    attrs: {
                                      label: `${item.code}-${item.name}`,
                                      value: item.code,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("template", { slot: "reference" }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  gap: "10px",
                                },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "icon",
                                    staticStyle: {
                                      width: "25px",
                                      height: "25px",
                                    },
                                    attrs: {
                                      t: "1773033703334",
                                      viewBox: "0 0 1024 1024",
                                      version: "1.1",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      "p-id": "4755",
                                      width: "128",
                                      height: "128",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        fill: "rgba(184, 184, 184, 1)",
                                        d: "M988.968421 512c0-264.084211-212.884211-476.968421-476.968421-476.968421C247.915789 35.031579 35.031579 247.915789 35.031579 512c0 261.389474 212.884211 476.968421 474.273684 476.968421h5.389474c261.389474 0 474.273684-215.578947 474.273684-476.968421zM167.073684 781.473684c-53.894737-70.063158-88.926316-156.294737-94.315789-250.610526h212.88421c0 43.115789 5.389474 115.873684 24.252632 188.631579-56.589474 13.473684-110.484211 32.336842-142.821053 61.978947zM164.378947 242.526316c32.336842 29.642105 86.231579 51.2 145.51579 64.673684-16.168421 72.757895-21.557895 142.821053-21.557895 185.936842H75.452632c2.694737-94.315789 35.031579-180.547368 88.926315-250.610526z m695.242106 0c53.894737 70.063158 86.231579 156.294737 91.621052 250.610526h-212.88421c0-43.115789-5.389474-113.178947-24.252632-185.936842 59.284211-13.473684 113.178947-35.031579 145.51579-64.673684zM700.631579 493.136842h-169.768421v-167.073684c43.115789 0 94.315789-5.389474 145.515789-13.473684 18.863158 72.757895 21.557895 142.821053 24.252632 180.547368z m-169.768421-204.8V83.536842c70.063158 37.726316 110.484211 115.873684 134.736842 194.021053-45.810526 8.084211-94.315789 10.778947-134.736842 10.778947z m-37.726316-204.8v204.8c-40.421053 0-88.926316-5.389474-134.736842-10.778947 21.557895-78.147368 64.673684-153.6 134.736842-194.021053z m0 242.526316v167.073684H323.368421c0-37.726316 5.389474-107.789474 24.252632-177.852631 53.894737 8.084211 107.789474 10.778947 145.515789 10.778947zM323.368421 530.863158h169.768421V700.631579c-37.726316 0-88.926316 2.694737-145.515789 13.473684-18.863158-75.452632-21.557895-145.515789-24.252632-183.242105z m169.768421 207.494737v202.105263c-70.063158-37.726316-110.484211-113.178947-134.736842-191.326316 45.810526-8.084211 94.315789-10.778947 134.736842-10.778947z m37.726316 202.105263v-202.105263c40.421053 0 88.926316 5.389474 134.736842 13.473684-24.252632 75.452632-64.673684 150.905263-134.736842 188.631579z m0-239.831579v-169.768421H700.631579c0 37.726316-5.389474 107.789474-24.252632 183.242105-51.2-8.084211-105.094737-13.473684-145.515789-13.473684z m207.494737-169.768421h212.88421c-5.389474 94.315789-37.726316 180.547368-94.315789 250.610526-32.336842-29.642105-86.231579-48.505263-142.821053-61.978947 16.168421-72.757895 21.557895-145.515789 24.252632-188.631579zM835.368421 215.578947c-26.947368 24.252632-75.452632 43.115789-129.347368 53.894737-21.557895-70.063158-56.589474-140.126316-113.178948-188.631579 94.315789 16.168421 177.852632 64.673684 242.526316 134.736842zM431.157895 80.842105c-56.589474 48.505263-91.621053 118.568421-113.178948 191.326316C264.084211 258.694737 215.578947 239.831579 188.631579 215.578947c64.673684-70.063158 148.210526-118.568421 242.526316-134.736842zM191.326316 811.115789c26.947368-24.252632 75.452632-43.115789 129.347368-53.894736 21.557895 70.063158 56.589474 140.126316 110.484211 185.936842-94.315789-16.168421-177.852632-64.673684-239.831579-132.042106zM592.842105 943.157895c56.589474-48.505263 88.926316-115.873684 110.484211-185.936842 53.894737 10.778947 102.4 29.642105 129.347368 53.894736-61.978947 67.368421-145.515789 115.873684-239.831579 132.042106z",
                                        "p-id": "4756",
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", [_vm._v(_vm._s(_vm.rate))]),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "el-icon-caret-bottom",
                                }),
                              ]
                            ),
                          ]),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.$router.push({
                                name: "Announcement",
                                query: {
                                  bool: false,
                                  phoneHomeImg: false,
                                  box8: false,
                                  noBusiness: true,
                                  home: true,
                                },
                              })
                            },
                          },
                        },
                        [
                          _vm._v(
                            "Website Announcement (" +
                              _vm._s(_vm.noticeTotal) +
                              ") "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.userType == 1 && _vm.userName
                        ? _c("div", { staticClass: "right_else" }, [
                            _c(
                              "span",
                              { staticClass: "showRed" },
                              [
                                _c(
                                  "el-dropdown",
                                  { attrs: { trigger: "click" } },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "el-dropdown-link" },
                                      [
                                        _vm._v("\n                  Notice"),
                                        _c("i", {
                                          staticClass:
                                            "el-icon-caret-bottom el-icon--right",
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-dropdown-menu",
                                      {
                                        attrs: { slot: "dropdown" },
                                        slot: "dropdown",
                                      },
                                      [
                                        _c(
                                          "el-dropdown-item",
                                          {
                                            staticClass: "clearfix",
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.viewCartClick.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    Shopping Cart\n                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.deliveryOrderCount
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                staticClass: "clearfix",
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.xfzOrderClick(
                                                      $event,
                                                      false
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Shipped order\n                    "
                                                ),
                                                _c("el-badge", {
                                                  staticClass: "mark",
                                                  attrs: {
                                                    value:
                                                      _vm.deliveryOrderCount,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { on: { click: _vm.personalcenterClick } },
                              [_vm._v("Hi, " + _vm._s(_vm.userName) + " !")]
                            ),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  cursor: "pointer",
                                  "margin-left": "10px",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.exitLogin()
                                  },
                                },
                              },
                              [_vm._v("exit")]
                            ),
                          ])
                        : _vm.userType == 2 && _vm.userName
                        ? _c("div", { staticClass: "right_else" }, [
                            _vm.enquiriesCount ||
                            _vm.feedbackCount ||
                            _vm.orderDeliveryCount ||
                            _vm.promotionApplyCount
                              ? _c(
                                  "span",
                                  { staticClass: "showRed" },
                                  [
                                    _c(
                                      "el-dropdown",
                                      { attrs: { trigger: "click" } },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "el-dropdown-link" },
                                          [
                                            _vm._v(
                                              "\n                  通知信息"
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "el-icon-caret-bottom el-icon--right",
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-dropdown-menu",
                                          {
                                            attrs: { slot: "dropdown" },
                                            slot: "dropdown",
                                          },
                                          [
                                            _vm.enquiriesCount
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    staticClass: "clearfix",
                                                    nativeOn: {
                                                      click: function ($event) {
                                                        return _vm.fxpclick()
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    待审核询盘\n                    "
                                                    ),
                                                    _c("el-badge", {
                                                      staticClass: "mark",
                                                      attrs: {
                                                        value:
                                                          _vm.enquiriesCount,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.feedbackCount
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    staticClass: "clearfix",
                                                    nativeOn: {
                                                      click: function ($event) {
                                                        return _vm.feedbackClick(
                                                          $event,
                                                          false
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    未读反馈\n                    "
                                                    ),
                                                    _c("el-badge", {
                                                      staticClass: "mark",
                                                      attrs: {
                                                        value:
                                                          _vm.feedbackCount,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.orderDeliveryCount
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    staticClass: "clearfix",
                                                    nativeOn: {
                                                      click: function ($event) {
                                                        return _vm.orderClick(
                                                          $event,
                                                          false
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    待发货订单\n                    "
                                                    ),
                                                    _c("el-badge", {
                                                      staticClass: "mark",
                                                      attrs: {
                                                        value:
                                                          _vm.orderDeliveryCount,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.promotionApplyCount
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    staticClass: "clearfix",
                                                    nativeOn: {
                                                      click: function ($event) {
                                                        return _vm.promotionClick(
                                                          $event,
                                                          false
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    待审核分销\n                    "
                                                    ),
                                                    _c("el-badge", {
                                                      staticClass: "mark",
                                                      attrs: {
                                                        value:
                                                          _vm.promotionApplyCount,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "span",
                              { on: { click: _vm.businesspersonalClick } },
                              [_vm._v("Hi, " + _vm._s(_vm.userName) + " !")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  cursor: "pointer",
                                  "margin-left": "10px",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.exitLogin()
                                  },
                                },
                              },
                              [_vm._v("\n              exit\n            ")]
                            ),
                          ])
                        : _c("nav", { staticClass: "right flex-row" }, [
                            _c(
                              "div",
                              {
                                staticClass: "right_1",
                                on: {
                                  click: function ($event) {
                                    return _vm.loginClick(false)
                                  },
                                },
                              },
                              [_vm._v("Login")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "right_2",
                                on: {
                                  click: function ($event) {
                                    return _vm.registerClick(false)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Register for buyer\n            "
                                ),
                              ]
                            ),
                          ]),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "box_2" }, [
            _c(
              "div",
              {
                staticClass: "flex-row justify-between align-center main",
                staticStyle: { gap: "10px" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "left",
                    on: {
                      click: function ($event) {
                        return _vm.homeClick(true)
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "image_1",
                      attrs: {
                        alt: "图片",
                        referrerpolicy: "no-referrer",
                        src: require("assets/img/applogo.png"),
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _vm.announcement
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          flex: "0 0 850px",
                          color: "#ce4c5a",
                          display: "flex",
                          "align-items": "center",
                          gap: "20px",
                          "font-weight": "bold",
                          "font-size": "22px",
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-message-solid",
                          staticStyle: { "font-size": "28px" },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "container1" }, [
                          _c(
                            "div",
                            {
                              staticClass: "notification",
                              style: {
                                animation: `scroll-left ${
                                  (_vm.announcement?.length || 1) * 0.08
                                }s linear infinite`,
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.announcement) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.shareType
                  ? _c(
                      "div",
                      { staticClass: "right" },
                      [
                        _vm.noBusiness == "true" || _vm.noBusiness == null
                          ? _c(
                              "el-input",
                              {
                                staticClass: "box_input",
                                attrs: {
                                  placeholder: "Search keywords ...",
                                  type: "search",
                                },
                                model: {
                                  value: _vm.form.keyword,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "keyword", $$v)
                                  },
                                  expression: "form.keyword",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      slot: "append",
                                      placeholder: "请选择",
                                    },
                                    slot: "append",
                                    model: {
                                      value: _vm.selectVal,
                                      callback: function ($$v) {
                                        _vm.selectVal = $$v
                                      },
                                      expression: "selectVal",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: "Products",
                                        value: "Products",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label: "Manufacturers",
                                        value: "Manufacturers",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.keyword,
                                  expression: "form.keyword",
                                },
                              ],
                              attrs: {
                                type: "search",
                                placeholder: "Search keywords ...",
                              },
                              domProps: { value: _vm.form.keyword },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.form,
                                    "keyword",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                        _vm._v(" "),
                        _c("button", { on: { click: _vm.searchfun } }, [
                          _c("img", {
                            staticClass: "thumbnail_1",
                            attrs: {
                              alt: "图片",
                              referrerpolicy: "no-referrer",
                              src: "https://lanhu.oss-cn-beijing.aliyuncs.com/pswvfbw4rj03mwtd8pe9myjo7nmkgnok0o4fbdee42-9b9e-44c9-b9a4-fd0916fefc3f",
                            },
                          }),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.noBusiness == "true" || _vm.noBusiness == null
            ? _c("div", { staticClass: "box_3" }, [
                _c("nav", { staticClass: "main" }, [
                  _c(
                    "ul",
                    { staticClass: "flex-row justify-between gundong" },
                    [
                      _c(
                        "li",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.homeClick(true)
                            },
                          },
                        },
                        [_vm._v("Home")]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.commondata, function (item, index) {
                        return _c(
                          "li",
                          { key: index },
                          [
                            _c(
                              "el-dropdown",
                              {
                                attrs: { placement: "bottom-start" },
                                on: { command: _vm.ceramicsClick },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "el-dropdown-link",
                                    on: {
                                      click: function ($event) {
                                        return _vm.ceramicsClick(item.id)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.categoryName)
                                    ),
                                    item.children && item.children.length > 0
                                      ? _c("i", {
                                          staticClass:
                                            "el-icon-arrow-down el-icon--right",
                                        })
                                      : _vm._e(),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown",
                                  },
                                  _vm._l(
                                    item.children,
                                    function (item2, index2) {
                                      return _c(
                                        "el-dropdown-item",
                                        {
                                          key: index2,
                                          attrs: { command: item2.id },
                                        },
                                        [
                                          _c(
                                            "el-dropdown",
                                            {
                                              attrs: {
                                                placement: "bottom-start",
                                              },
                                              on: {
                                                command: _vm.ceramicsClick,
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "el-dropdown-link",
                                                  attrs: { id: "linkWhite1" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.ceramicsClick(
                                                        item2.id
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(item2.categoryName)
                                                  ),
                                                  item2.children &&
                                                  item2.children.length > 0
                                                    ? _c("i", {
                                                        staticClass:
                                                          "el-icon-arrow-down el-icon--right",
                                                      })
                                                    : _vm._e(),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-dropdown-menu",
                                                {
                                                  attrs: { slot: "dropdown" },
                                                  slot: "dropdown",
                                                },
                                                _vm._l(
                                                  item2.children,
                                                  function (item3, index3) {
                                                    return _c(
                                                      "el-dropdown-item",
                                                      {
                                                        key: index3,
                                                        attrs: {
                                                          command: item3.id,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              item3.categoryName
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                ]),
              ])
            : _c("div", { staticClass: "business_box_3" }, [
                _vm.show
                  ? _c("div", { staticClass: "business_topimg" }, [
                      _c("img", {
                        staticClass: "bg_img",
                        staticStyle: { height: "200px", width: "100%" },
                        attrs: {
                          alt: "图片",
                          src:
                            this.$baseUrl +
                            (_vm.businessTopLog && _vm.businessTopLog.length > 0
                              ? _vm.businessTopLog[0].image
                              : ""),
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "business_topimg_content" }, [
                        _c(
                          "div",
                          {
                            staticClass: "business_topimg_content_left",
                            staticStyle: {
                              "text-align": "left",
                              "margin-left": "calc(180* 100vw / 1920)",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "business_topimg_content_left_details",
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      "font-size": "15px",
                                      "font-weight": "600",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: { click: _vm.businesshomeClick },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.businessInfo.businessName
                                              ? _vm.businessInfo.businessName
                                              : ""
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("p", {
                                  staticStyle: { "font-size": "13px" },
                                }),
                                _vm.businessInfo.producer ||
                                _vm.businessInfo.establishment
                                  ? _c("p", { staticClass: "maxDis" }, [
                                      _vm.businessInfo.producer ||
                                      _vm.businessInfo.establishment
                                        ? _c("img", {
                                            attrs: {
                                              alt: "图片",
                                              src: require("assets/img/location.png"),
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.businessInfo.producer
                                              ? _vm.businessInfo.producer
                                              : ""
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.businessInfo.establishment
                                              ? _vm.businessInfo.establishment
                                              : ""
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.businessInfo.phone
                                  ? _c("p", { staticClass: "maxDis" }, [
                                      _vm.businessInfo.phone
                                        ? _c("img", {
                                            attrs: {
                                              alt: "图片",
                                              src: require("assets/img/phone.png"),
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.businessInfo.phone
                                              ? _vm.businessInfo.phone
                                              : ""
                                          ) +
                                          "\n              "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.businessInfo.wxAccount
                                  ? _c("p", { staticClass: "maxDis" }, [
                                      _vm.businessInfo.wxAccount
                                        ? _c("img", {
                                            attrs: {
                                              alt: "图片",
                                              src: require("assets/img/wechat1.png"),
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.businessInfo.wxAccount
                                              ? _vm.businessInfo.wxAccount
                                              : ""
                                          ) +
                                          "\n              "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.businessInfo.whatsapp
                                  ? _c("p", { staticClass: "maxDis" }, [
                                      _vm.businessInfo.whatsapp
                                        ? _c("img", {
                                            attrs: {
                                              alt: "图片",
                                              src: require("assets/img/telephone.png"),
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.businessInfo.whatsapp
                                              ? _vm.businessInfo.whatsapp
                                              : ""
                                          ) +
                                          "\n                "
                                      ),
                                      _c("label"),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.businessInfo.email
                                  ? _c("p", { staticClass: "maxDis" }, [
                                      _vm.businessInfo.email
                                        ? _c("img", {
                                            attrs: {
                                              alt: "图片",
                                              src: require("assets/img/youxiang.png"),
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.businessInfo.email
                                              ? _vm.businessInfo.email
                                              : ""
                                          ) +
                                          "\n              "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("p"),
                                _vm._v(" "),
                                _vm.businessInfo.address
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "font-size": "12px",
                                          display: "flex",
                                          "align-items": "center",
                                          "line-height": "16px",
                                        },
                                      },
                                      [
                                        _vm.businessInfo.address
                                          ? _c("img", {
                                              attrs: {
                                                alt: "图片",
                                                src: require("assets/img/location.png"),
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.businessInfo.address
                                                ? _vm.businessInfo.address
                                                : ""
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "business_topimg_content_right",
                            staticStyle: {
                              position: "relative",
                              left: "calc(-400* 100vw / 1920)",
                              "text-align": "center",
                              top: "calc(15* 100vw / 1080)",
                            },
                          },
                          [
                            _vm.businessInfo.codeImage
                              ? _c("img", {
                                  attrs: {
                                    alt: "图片",
                                    src:
                                      this.$baseUrl +
                                      _vm.businessInfo.codeImage,
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "maxDis",
                                staticStyle: {
                                  "margin-top": "calc(20* 100vw / 1080)",
                                },
                              },
                              [
                                _vm.businessInfo.comprehensiveScore &&
                                _vm.businessInfo.comprehensiveScore > 0
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.businessInfo.comprehensiveScore
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ])
                  : _c(
                      "div",
                      {
                        staticClass: "business_topimg",
                        style: {
                          "background-color":
                            _vm.businessTopLog &&
                            _vm.businessTopLog.length > 0 &&
                            _vm.businessTopLog[0].image
                              ? ""
                              : "#CCC",
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "bg_img",
                          attrs: {
                            alt: "图片",
                            src:
                              this.$baseUrl +
                              (_vm.businessTopLog &&
                              _vm.businessTopLog.length > 0
                                ? _vm.businessTopLog[0].image
                                : ""),
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "business_topimg_content" }, [
                          _c(
                            "div",
                            { staticClass: "business_topimg_content_left" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "business_topimg_content_left_img",
                                },
                                [
                                  _vm.businessInfo.logoImage
                                    ? _c("img", {
                                        attrs: {
                                          alt: "图片",
                                          src:
                                            this.$baseUrl +
                                            _vm.businessInfo.logoImage,
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "business_topimg_content_left_details",
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        "font-size": "15px",
                                        "font-weight": "600",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { cursor: "pointer" },
                                          on: { click: _vm.businesshomeClick },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.businessInfo.businessName
                                                ? _vm.businessInfo.businessName
                                                : ""
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    { staticStyle: { "font-size": "13px" } },
                                    [
                                      _vm.businessInfo.phone
                                        ? _c("img", {
                                            attrs: {
                                              alt: "图片",
                                              src: require("assets/img/phone.png"),
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.businessInfo.phone
                                              ? _vm.businessInfo.phone
                                              : ""
                                          ) +
                                          "\n                "
                                      ),
                                      _vm.businessInfo.phone
                                        ? _c("span", [_vm._v("/")])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.businessInfo.wxAccount
                                        ? _c("img", {
                                            attrs: {
                                              alt: "图片",
                                              src: require("assets/img/wechat1.png"),
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.businessInfo.wxAccount
                                              ? _vm.businessInfo.wxAccount
                                              : ""
                                          ) +
                                          "\n                "
                                      ),
                                      _vm.businessInfo.wxAccount
                                        ? _c("span", [_vm._v("/")])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.businessInfo.whatsapp
                                        ? _c("img", {
                                            attrs: {
                                              alt: "图片",
                                              src: require("assets/img/telephone.png"),
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.businessInfo.whatsapp
                                              ? _vm.businessInfo.whatsapp
                                              : ""
                                          ) +
                                          "\n                "
                                      ),
                                      _c("label"),
                                      _vm._v(" "),
                                      _vm.businessInfo.email
                                        ? _c("img", {
                                            attrs: {
                                              alt: "图片",
                                              src: require("assets/img/youxiang.png"),
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.businessInfo.email
                                              ? _vm.businessInfo.email
                                              : ""
                                          ) +
                                          "\n                "
                                      ),
                                      _vm._v(" "),
                                      _vm.businessInfo.comprehensiveScore &&
                                      _vm.businessInfo.comprehensiveScore > 0
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.businessInfo
                                                  .comprehensiveScore
                                              )
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.businessInfo.producer
                                              ? _vm.businessInfo.producer
                                              : ""
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.businessInfo.establishment
                                              ? _vm.businessInfo.establishment
                                              : ""
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        display: "flex",
                                        "align-items": "center",
                                        "line-height": "16px",
                                      },
                                    },
                                    [
                                      _vm.businessInfo.address
                                        ? _c("img", {
                                            attrs: {
                                              alt: "图片",
                                              src: require("assets/img/location.png"),
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.businessInfo.address
                                              ? _vm.businessInfo.address
                                              : ""
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "business_topimg_content_right" },
                            [
                              _vm.businessInfo.codeImage
                                ? _c("img", {
                                    attrs: {
                                      alt: "图片",
                                      src:
                                        this.$baseUrl +
                                        _vm.businessInfo.codeImage,
                                    },
                                  })
                                : _vm._e(),
                            ]
                          ),
                        ]),
                      ]
                    ),
                _vm._v(" "),
                !_vm.shareType
                  ? _c(
                      "nav",
                      { staticClass: "main", staticStyle: { height: "4vw" } },
                      [
                        _c(
                          "ul",
                          { staticClass: "flex-row gundong" },
                          [
                            _c(
                              "li",
                              [
                                _c(
                                  "el-dropdown",
                                  { attrs: { placement: "bottom-start" } },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "el-dropdown-link",
                                        on: { click: _vm.businesshomeClick },
                                      },
                                      [_vm._v("Home")]
                                    ),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass:
                                        "el-icon-arrow-down el-icon--right",
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "el-dropdown-menu",
                                      {
                                        attrs: { slot: "dropdown" },
                                        slot: "dropdown",
                                      },
                                      _vm._l(
                                        _vm.businessNav,
                                        function (item, index) {
                                          return item.id !== 637
                                            ? _c(
                                                "el-dropdown-item",
                                                {
                                                  key: index,
                                                  attrs: { command: item.id },
                                                },
                                                [
                                                  _c(
                                                    "el-dropdown",
                                                    {
                                                      attrs: {
                                                        placement:
                                                          "bottom-start",
                                                      },
                                                      on: {
                                                        command:
                                                          _vm.businessceramicsClick,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "el-dropdown-link",
                                                          attrs: {
                                                            id: "linkWhite",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.businessceramicsClick(
                                                                item.id,
                                                                false
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                item.categoryName
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                      item.children &&
                                                      item.children.length > 0
                                                        ? _c("i", {
                                                            staticClass:
                                                              "el-icon-arrow-down el-icon--right",
                                                          })
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      item.children
                                                        ? _c(
                                                            "el-dropdown-menu",
                                                            {
                                                              attrs: {
                                                                slot: "dropdown",
                                                              },
                                                              slot: "dropdown",
                                                            },
                                                            _vm._l(
                                                              item.children,
                                                              function (
                                                                item2,
                                                                index2
                                                              ) {
                                                                return _c(
                                                                  "el-dropdown-item",
                                                                  {
                                                                    key: index2,
                                                                    attrs: {
                                                                      command:
                                                                        item2.id,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-dropdown",
                                                                      {
                                                                        attrs: {
                                                                          placement:
                                                                            "bottom-start",
                                                                        },
                                                                        on: {
                                                                          command:
                                                                            _vm.businessceramicsClick,
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "el-dropdown-link",
                                                                            attrs:
                                                                              {
                                                                                id: "linkWhite",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.businessceramicsClick(
                                                                                    item2.id
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                            " +
                                                                                _vm._s(
                                                                                  item2.categoryName
                                                                                )
                                                                            ),
                                                                            item2.children &&
                                                                            item2
                                                                              .children
                                                                              .length >
                                                                              0
                                                                              ? _c(
                                                                                  "i",
                                                                                  {
                                                                                    staticClass:
                                                                                      "el-icon-arrow-down el-icon--right",
                                                                                  }
                                                                                )
                                                                              : _vm._e(),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        item2.children
                                                                          ? _c(
                                                                              "el-dropdown-menu",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    slot: "dropdown",
                                                                                  },
                                                                                slot: "dropdown",
                                                                              },
                                                                              _vm._l(
                                                                                item2.children,
                                                                                function (
                                                                                  item3,
                                                                                  index3
                                                                                ) {
                                                                                  return _c(
                                                                                    "el-dropdown-item",
                                                                                    {
                                                                                      key: index3,
                                                                                      attrs:
                                                                                        {
                                                                                          command:
                                                                                            item3.id,
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "\n                              " +
                                                                                          _vm._s(
                                                                                            item3.categoryName
                                                                                          ) +
                                                                                          "\n                            "
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                }
                                                                              ),
                                                                              1
                                                                            )
                                                                          : _vm._e(),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.businessNav, function (item, index) {
                              return item.id == 637
                                ? _c(
                                    "li",
                                    { key: index },
                                    [
                                      _c(
                                        "el-dropdown",
                                        {
                                          attrs: { placement: "bottom-start" },
                                          on: {
                                            command: _vm.businessceramicsClick,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "el-dropdown-link",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.businessceramicsClick(
                                                    item.id,
                                                    false
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(item.categoryName) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          item.children &&
                                          item.children.length > 0
                                            ? _c("i", {
                                                staticClass:
                                                  "el-icon-arrow-down el-icon--right",
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "el-dropdown-menu",
                                            {
                                              attrs: { slot: "dropdown" },
                                              slot: "dropdown",
                                            },
                                            _vm._l(
                                              item.children,
                                              function (item2, index2) {
                                                return _c(
                                                  "el-dropdown-item",
                                                  {
                                                    key: index2,
                                                    attrs: {
                                                      command: item2.id,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-dropdown",
                                                      {
                                                        attrs: {
                                                          placement:
                                                            "bottom-start",
                                                        },
                                                        on: {
                                                          command:
                                                            _vm.businessceramicsClick,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "el-dropdown-link",
                                                            attrs: {
                                                              id: "linkWhite",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.businessceramicsClick(
                                                                  item2.id
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  item2.categoryName
                                                                )
                                                            ),
                                                            item2.children &&
                                                            item2.children
                                                              .length > 0
                                                              ? _c("i", {
                                                                  staticClass:
                                                                    "el-icon-arrow-down el-icon--right",
                                                                })
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        item2.children
                                                          ? _c(
                                                              "el-dropdown-menu",
                                                              {
                                                                attrs: {
                                                                  slot: "dropdown",
                                                                },
                                                                slot: "dropdown",
                                                              },
                                                              _vm._l(
                                                                item2.children,
                                                                function (
                                                                  item3,
                                                                  index3
                                                                ) {
                                                                  return _c(
                                                                    "el-dropdown-item",
                                                                    {
                                                                      key: index3,
                                                                      attrs: {
                                                                        command:
                                                                          item3.id,
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                        " +
                                                                          _vm._s(
                                                                            item3.categoryName
                                                                          ) +
                                                                          "123\n                      "
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              1
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e()
                            }),
                            _vm._v(" "),
                            _c(
                              "li",
                              [
                                _c(
                                  "el-dropdown",
                                  {
                                    attrs: { placement: "bottom-start" },
                                    on: { command: _vm.businessnewsClick },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "el-dropdown-link" },
                                      [_vm._v("Profile")]
                                    ),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass:
                                        "el-icon-arrow-down el-icon--right",
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "el-dropdown-menu",
                                      {
                                        attrs: { slot: "dropdown" },
                                        slot: "dropdown",
                                      },
                                      [
                                        _c(
                                          "el-dropdown-item",
                                          {
                                            attrs: {
                                              command: "CompanyOverview",
                                            },
                                          },
                                          [_vm._v("Company Overview")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-dropdown-item",
                                          {
                                            attrs: {
                                              command: "RatingsReviews",
                                            },
                                          },
                                          [_vm._v("Ratings & Reviews")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { on: { click: _vm.businessfeedbackClick } },
                              [_vm._v("Feedback")]
                            ),
                            _vm._v(" "),
                            _c("li", { on: { click: _vm.contactUsClick } }, [
                              _vm._v("ContactUs"),
                            ]),
                          ],
                          2
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
          _vm._v(" "),
          _c(
            "keep-alive",
            {
              attrs: {
                include:
                  "Ceramics,PersonalCenter,FineCeramics,BusinessPersonal",
              },
            },
            [_c("Nuxt")],
            1
          ),
          _vm._v(" "),
          (_vm.noBusiness == "true" || _vm.noBusiness == null) && _vm.box8
            ? _c("div", { staticClass: "box_8" }, [
                _c("div", { staticClass: "conent justify-between main" }, [
                  _c("div", { staticClass: "left" }, [
                    _c("span", [_vm._v("Buyer join for free")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "email flex-row" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.registerUser.email,
                            expression: "registerUser.email",
                          },
                        ],
                        attrs: {
                          type: "text",
                          placeholder: "Please fill in your email address",
                        },
                        domProps: { value: _vm.registerUser.email },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.registerUser,
                              "email",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "code flex-row justify-between" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.registerUser.code,
                              expression: "registerUser.code",
                            },
                          ],
                          attrs: {
                            type: "text",
                            placeholder: "Fill in the verification code",
                          },
                          domProps: { value: _vm.registerUser.code },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.registerUser,
                                "code",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("button", { on: { click: _vm.sendEmailCodeApi } }, [
                          _vm._v("Verify Mailbox"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "email flex-row" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.registerUser.password,
                            expression: "registerUser.password",
                          },
                        ],
                        attrs: {
                          type: "password",
                          placeholder: "Set Password",
                        },
                        domProps: { value: _vm.registerUser.password },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.registerUser,
                              "password",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "register" }, [
                      _c("button", { on: { click: _vm.registerEmailApi } }, [
                        _vm._v("Buyer Register Now !"),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mid" }, [
                    _c("span", [_vm._v("CONTACT INFO")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "message flex-col justify-between" },
                      [
                        _c("div", { staticClass: "address" }, [
                          _c("img", {
                            attrs: {
                              alt: "图片",
                              referrerpolicy: "no-referrer",
                              src: "https://lanhu.oss-cn-beijing.aliyuncs.com/ps6scfsp2rxl4oc0eo3eyygdp3e7u2vnxtd3ee886c-ba50-4047-bf46-557b93ae6aa0",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "text1" }, [
                            _vm._v("Address:"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "text2" }, [
                            _vm._v(_vm._s(_vm.contactInfo.address)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "phone" }, [
                          _c("img", {
                            attrs: {
                              alt: "图片",
                              referrerpolicy: "no-referrer",
                              src: "https://lanhu.oss-cn-beijing.aliyuncs.com/psyxernbqvyltnb5354a0oydrt2ebwfve372643b-8be4-4b8a-a61e-7351f7eb5e8e",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "text1" }, [
                            _vm._v("Phone/Wechat:"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "text2" }, [
                            _vm._v(_vm._s(_vm.contactInfo.phone)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "phone" }, [
                          _vm._m(2),
                          _vm._v(" "),
                          _c("span", { staticClass: "text2" }, [
                            _vm._v(_vm._s(_vm.contactInfo.qq)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "email" }, [
                          _c("img", {
                            attrs: {
                              alt: "图片",
                              referrerpolicy: "no-referrer",
                              src: "https://lanhu.oss-cn-beijing.aliyuncs.com/pspfwlik28j3qtu99zxjcm88ij9des04ofdd90824-97d4-439b-ae0b-7eb5cebde1a4",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "text1" }, [
                            _vm._v("Email:"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "text2" }, [
                            _vm._v(_vm._s(_vm.contactInfo.email)),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "right" }, [
                    _c("span", { staticClass: "span1" }, [
                      _vm._v("CONTACT US"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "span3",
                        on: {
                          click: function ($event) {
                            return _vm.aboutUsClick(false)
                          },
                        },
                      },
                      [
                        _c("div", [_vm._v("About Us")]),
                        _vm._v(" "),
                        _c("button", [_vm._v(">")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "span3",
                        on: {
                          click: function ($event) {
                            return _vm.helpClick()
                          },
                        },
                      },
                      [
                        _c("div", [_vm._v("Buyer Help center")]),
                        _vm._v(" "),
                        _c("button", [_vm._v(">")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "span3",
                        on: {
                          click: function ($event) {
                            return _vm.merchantHelpClick()
                          },
                        },
                      },
                      [
                        _c("div", [_vm._v("Supplier Help center")]),
                        _vm._v(" "),
                        _c("button", [_vm._v(">")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "span3 span4",
                        on: {
                          click: function ($event) {
                            return _vm.helpCenterClick("c")
                          },
                        },
                      },
                      [
                        _c("div", [_vm._v("Article help Center")]),
                        _vm._v(" "),
                        _c("button", [_vm._v(">")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "span3",
                        on: {
                          click: function ($event) {
                            return _vm.quotationsClick()
                          },
                        },
                      },
                      [
                        _c("div", [_vm._v("Request a Quote")]),
                        _vm._v(" "),
                        _c("button", [_vm._v(">")]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "right2" }, [
                    _c("span", { staticClass: "span1" }, [_vm._v("Sharing")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "span3 right2Height" }, [
                      _c(
                        "div",
                        { staticClass: "buttom_share_loge" },
                        _vm._l(
                          _vm.indexBottomNavigation,
                          function (item, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "shareDiv" },
                              [
                                _c("img", {
                                  attrs: {
                                    alt: "图片",
                                    src: _vm.$baseUrl + item.navigationImage,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.buttomOpenNewPage(
                                        item.navigationUrl
                                      )
                                    },
                                  },
                                }),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _vm.userType == 1 ||
          _vm.noBusiness == "true" ||
          _vm.noBusiness == null
            ? _c("div", { staticClass: "bottomnav flex-row" }, [
                _c(
                  "div",
                  {
                    staticClass: "bottomnav_home",
                    on: {
                      click: function ($event) {
                        return _vm.bottomnavClick($event, "/", true)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "iconfont icon-home" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "bottomnav-text" }, [
                      _vm._v("Home"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "bottomnav_classify",
                    on: {
                      click: function ($event) {
                        return _vm.bottomnavClick($event, "/ceramics", false)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "iconfont icon-classify" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "bottomnav-text" }, [
                      _vm._v("CLASSIFY"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "bottomnav_about",
                    on: {
                      click: function ($event) {
                        return _vm.bottomnavClick(
                          $event,
                          "/companyprofile",
                          false
                        )
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "iconfont icon-about" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "bottomnav-text" }, [
                      _vm._v("ABOUT"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "bottomnav_me",
                    on: {
                      click: function ($event) {
                        return _vm.bottomnavMeClick(
                          $event,
                          _vm.personalCenterPath,
                          false
                        )
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "iconfont icon-me" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "bottomnav-text" }, [
                      _vm._v("ME"),
                    ]),
                  ]
                ),
              ])
            : _c("div", { staticClass: "bottomnav flex-row" }, [
                _c(
                  "div",
                  {
                    staticClass: "bottomnav_home",
                    on: { click: _vm.businesshomeClick },
                  },
                  [
                    _c("div", { staticClass: "iconfont icon-home" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "bottomnav-text" }, [
                      _vm._v("Home"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "bottomnav_classify",
                    on: {
                      click: function ($event) {
                        return _vm.businessceramicsClick(_vm.businessId, true)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "iconfont icon-chanpin" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "bottomnav-text" }, [
                      _vm._v("PRODUCTS"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "bottomnav_about",
                    on: { click: _vm.businessprofileClick },
                  },
                  [
                    _c("div", { staticClass: "iconfont icon-about" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "bottomnav-text" }, [
                      _vm._v("ABOUT"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "bottomnav_me",
                    on: {
                      click: function ($event) {
                        return _vm.bottomnavMeClick(
                          $event,
                          _vm.personalCenterPath,
                          false
                        )
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "iconfont icon-me" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "bottomnav-text" }, [
                      _vm._v("ME"),
                    ]),
                  ]
                ),
              ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("BackToTop"),
      _vm._v(" "),
      !_vm.pageReady
        ? _c("div", { staticClass: "page-loading-overlay" }, [_vm._m(4)])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "languageAndcurrency", visible: _vm.dialogVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px", "margin-top": "20px" } },
            [_vm._v("currency")]
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              on: { change: _vm.changeRateEvent },
              model: {
                value: _vm.rate,
                callback: function ($$v) {
                  _vm.rate = $$v
                },
                expression: "rate",
              },
            },
            _vm._l(_vm.rateDataList, function (item) {
              return _c("el-option", {
                key: item.code,
                attrs: { label: `${item.code}-${item.name}`, value: item.code },
              })
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img" }, [
      _c("img", {
        attrs: { alt: "图片", src: require("assets/img/邮件拷贝.png") },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img" }, [
      _c("img", {
        attrs: { alt: "图片", src: require("assets/img/密码.png") },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "margin-top": "0.25vw",
          "align-items": "center",
        },
      },
      [
        _c("img", {
          staticClass: "qq",
          attrs: { alt: "图片", src: require("@/assets/img/QQ.png") },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "text1" }, [_vm._v("QQ:")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "box_9" }, [
      _c("img", {
        staticClass: "logo-img",
        attrs: {
          alt: "图片",
          src: require("@/assets/img/homeLogo.png"),
          referrerpolicy: "no-referrer",
        },
      }),
      _vm._v(" "),
      _c("span", [_vm._v("© 2022 E-Touch All rights reserved")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "page-loading-content" }, [
      _c("div", { staticClass: "loading-dot-spinner" }, [
        _c("span"),
        _vm._v(" "),
        _c("span"),
        _vm._v(" "),
        _c("span"),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("Loading...")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }